import { Link } from 'react-router-dom';
import { Section } from '../layout/Section';
import { SectionHeader } from '../layout/SectionHeader';
import { Pill } from '../ui/Pill';
import { Picture } from '../ui/Picture';
import { Button, RoundButton } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { articles } from '../../data/landing';
import styles from './Articles.module.css';

export function Articles() {
  const { featured } = articles;

  return (
    <Section id="articles">
      <SectionHeader
        eyebrow={articles.eyebrow}
        title={articles.title}
        subtitle={articles.subtitle}
        align="start"
      />

      <Reveal className={styles.grid}>
        <article className={`${styles.featured} zoom-target`}>
          <div className={styles.featuredMedia}>
            <Pill size="sm" className={styles.age}>
              {featured.age}
            </Pill>
            <Picture name={featured.image} alt="" sizes="(max-width: 1023px) 92vw, 50vw" zoom fill className={styles.media} />
          </div>

          <div className={styles.row}>
            <div>
              <h3 className={`${styles.title} u-h3`}>
                <Link to={featured.to}>{featured.title}</Link>
              </h3>
              <p className={`${styles.excerpt} u-body-lg`}>{featured.excerpt}</p>
            </div>
            <RoundButton icon="arrow-up-right" variant="dark" label={`Read: ${featured.title}`} to={featured.to} />
          </div>
        </article>

        <div className={styles.side}>
          {articles.items.map((item) => (
            <article key={item.title} className={`${styles.item} zoom-target`}>
              <div className={styles.itemMedia}>
                <Pill size="sm" className={styles.age}>
                  {item.age}
                </Pill>
                <Picture name={item.image} alt="" sizes="(max-width: 520px) 92vw, 22vw" zoom fill className={styles.media} />
              </div>

              <div>
                <h3 className={`${styles.title} u-h3`}>
                  <Link to={item.to}>{item.title}</Link>
                </h3>
                <p className={`${styles.excerpt} u-body`}>{item.excerpt}</p>
                <RoundButton
                  icon="arrow-up-right"
                  variant="dark"
                  size={48}
                  label={`Read: ${item.title}`}
                  to={item.to}
                  style={{ marginTop: 'var(--space-4)' }}
                />
              </div>
            </article>
          ))}
        </div>
      </Reveal>

      <div className={styles.cta}>
        <Button to={articles.cta.to} icon="arrow-right-circle">
          {articles.cta.label}
        </Button>
      </div>
    </Section>
  );
}
